// src/main.js
import { createApp } from "vue";
import router from "./router";
import "vuetify/styles"; // Vuetify CSS
import { createVuetify } from "vuetify";
import * as components from "vuetify/components"; // All standard Vuetify components
import * as directives from "vuetify/directives"; // All standard Vuetify directives
import "@mdi/font/css/materialdesignicons.css"; // Material Design Icons for Vuetify icons
import App from "./App.vue";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { VCalendar } from "vuetify/labs/VCalendar"; // Import VCalendar from Vuetify Labs
import { createPinia } from "pinia";
import { VDateInput } from "vuetify/labs/VDateInput";
import { initializeAuth } from "@/composable"; // Add this import

import { useAuth } from "@/composable";
const pinia = createPinia();
const vuetify = createVuetify({
  components: {
    // Spread all standard Vuetify components first
    ...components,
    VDateInput,
    // Then explicitly add VCalendar to the components object. This is correct.
    VCalendar,
  },
  directives, // Directives are fine as they are
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
});

// Initialize auth before creating the app
initializeAuth()
  .then(() => {
    createApp(App).use(pinia).use(vuetify).use(router).mount("#app");
  })
  .catch((error) => {
    console.error("Failed to initialize auth:", error);
    // Still create the app but with error state
    createApp(App).use(pinia).use(vuetify).use(router).mount("#app");
  });
